import * as React from 'react';
const SvgEyeOn = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={11}
    fill="none"
    viewBox="0 0 18 11"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 3.244a3.702 3.702 0 1 1 0 7.404 3.702 3.702 0 0 1 0-7.404m0 1.388a2.314 2.314 0 1 0 0 4.627 2.314 2.314 0 0 0 0-4.627M9 0a9.26 9.26 0 0 1 8.98 7 .694.694 0 0 1-1.348.338 7.87 7.87 0 0 0-15.264.004.694.694 0 0 1-1.347-.336A9.26 9.26 0 0 1 9 0"
    />
  </svg>
);
export default SvgEyeOn;
